import { render, staticRenderFns } from "./ViewDynamicReports.vue?vue&type=template&id=b0b27cb4&"
import script from "./ViewDynamicReports.vue?vue&type=script&lang=js&"
export * from "./ViewDynamicReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports